export enum Author {
  USER = "user",
  TOKEN = "token",
  REFRESH_TOKEN = "refreshToken",
}